import { styled } from '@mui/material';
import { FormControl, InputGroup } from 'react-bootstrap';

export const CustomButton = styled('div')`
  z-index: 100;
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  line-height: 19.84px;
  cursor: pointer;

  &:hover {
    background: none;
  }

  border: transparent;
`;

export const CustomInputGroup = styled(InputGroup)`
  position: relative;
  border: 1px solid;
  border-radius: 8px;

  font-weight: 400;
  line-height: 19.84px;

  input::placeholder {
    font-weight: 400;
    line-height: 19.84px;
  }
`;

export const StyledFormControl = styled(FormControl)`
  border: transparent !important;
  border-radius: 8px !important;
`;

export const Label = styled('div')`
  font-weight: 600;
  line-height: 17.36px;
`;

export const PromoCode = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;
`;
